module.exports = __webpack_public_path__ + "static/img/ding.d47c5d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ding.png
// module id = x2i3
// module chunks = 1